import React from 'react';
import InputMask from 'react-input-mask';//https://github.com/sanniassin/react-input-mask

class SimpleInput extends React.Component{
  constructor(props) {
    super(props);
    this.state = {};
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });

    if(this.props.onChange)
    this.props.onChange(event);
  }

  renderMaskInput() {
    return(
      <div className='input-mask-field'>
        <InputMask
          {...this.props.inputMask}
          value={this.props.value}
          onChange={this.handleChange}
        />
      </div>);
  }

  renderInput () {
    return (
      <input
        readOnly={this.props.readOnly}
        autoComplete="off"
        onChange={this.handleChange}
        className="box-input--input"
        placeholder={this.props.placeholder}
        type={this.props.type}
        value={this.props.value}
        name={this.props.name} />
    );
  }

  render () {

    const input = this.props.inputMask ? this.renderMaskInput() : this.renderInput();
      return (
        input
      );
  }
};

export default SimpleInput;



// WEBPACK FOOTER //
// ./src/components/form/SimpleInput.js